module.exports = __webpack_public_path__ + "img/plan_3.f0baebac.webp";